import { postData, getData, getExtData } from './api';
import * as config from '../config';

export const getTransferTypes = () => getData(config.getTransferTypesApiUrl);
export const getPaymentMethods = () => getData(config.getPaymentMethodsApiUrl);
export const getNetworksList = (phoneNumber) =>
  getData(`${config.getNetworksApiUrl}?phoneNumber=${encodeURIComponent(phoneNumber)}`);
export const getConversionRate = (currencyTo) =>
  getData(`${config.getConversionRateApiUrl}?currencyTo=${currencyTo}`);
export const getUserLocationInfoExt = () => getExtData(config.getUserLocationInfoExtApiUrl);
export const postReceiptEmail = (transferId, receiptEmail) =>
  postData(`${config.postTransferApiUrl}/${transferId}/receipt-email`, { receiptEmail });

export { postGuestLogin, postConfirmGuestLogin, postResendSmsCode } from './senderApi';
export { postPretransfer, postTransfer, getTransfer } from './transferApi';
